export { default } from './CreateDashboardLink';
export { default as reducer } from './CreateDashboardLink.ducks';
export { default as sagas } from './CreateDashboardLink.sagas';

import * as actions from './CreateDashboardLink.ducks';
export { actions };
